import React, { useState, useRef, useEffect } from 'react';
import { FiHelpCircle } from 'react-icons/fi';

export default function HelpTip({ text, size = 14, color = 'var(--text-muted)' }) {
  const [show, setShow] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!show) return;
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setShow(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [show]);

  return (
    <span ref={ref} style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', cursor: 'pointer' }}
      onClick={(e) => { e.stopPropagation(); setShow(!show); }}
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}>
      <FiHelpCircle size={size} color={show ? '#2563eb' : color} style={{ transition: 'color 0.15s' }} />
      {show && (
        <div style={{
          position: 'absolute', bottom: '100%', left: '50%', transform: 'translateX(-50%)',
          marginBottom: 6, padding: '8px 12px', borderRadius: 8,
          background: 'var(--bg-card)', border: '1px solid var(--border)',
          boxShadow: '0 8px 24px rgba(0,0,0,0.15)', fontSize: 12, color: 'var(--text-secondary)',
          lineHeight: 1.5, whiteSpace: 'normal', width: 240, zIndex: 100, fontWeight: 400,
          pointerEvents: 'none'
        }}>
          {text}
        </div>
      )}
    </span>
  );
}
